import {Component} from '@angular/core';
import {ParkComponent} from '@app/app/dashboard/parks/park/park.component';

@Component({
  selector: 'card-2',
  templateUrl: './card.2.html'
})

export class Card2Component extends ParkComponent {
  //
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/cards/card.2.component.ts